import React from "react";
import { useTheme } from "@mui/styles";
import { Typography, Box } from "@mui/material";
import WantToStartButton from "../Buttons/WantToStartButton";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
    backgroundImage:
      "linear-gradient(to bottom, rgba(0, 237, 213, 0.07) 0%, rgba(231, 240, 252, 0) 100%);",
    backgroundPosition: { xs: "center" },
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 1300px",
    height: { xs: "auto" },
    width: { xs: "100vw" },
  },
  firstCard: {
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
    background: "linear-gradient(to bottom, #23213f 0%, #03183d 100%)",
    height: { xs: "410px" },
    width: { xs: "299px" },
    borderRadius: "47px",
    mt: { xs: "50px" },
  },
  firstTitle: {
    color: theme.palette.green.main,
    fontSize: { xs: "30px" },
    lineHeight: { xs: "36px" },
    maxWidth: { xs: "245px" },
    height: { xs: "80px" },
    fontFamily: theme.typography.montserrat.bold,
    textAlign: { xs: "center" },
    mt: { xs: "1rem" },
  },
  firstSubtitle: {
    color: theme.palette.blue.light,
    fontFamily: theme.typography.anaHeim.regular,
    fontSize: { xs: "24px" },
    lineHeight: { xs: "36px" },
    maxWidth: { xs: "266px" },
    height: { xs: "141px" },
    mt: { xs: "4px" },
    textAlign: { xs: "center" },
  },
  icon: {
    height: { xs: "68px" },
    width: { xs: "68px" },
    color: theme.palette.green.main,
    mt: { xs: "58px" },
  },
  secondCard: {
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
    background: theme.palette.white.main,
    height: { xs: "410px" },
    width: { xs: "299px" },
    borderRadius: "47px",
    mt: { xs: "46px" },
    boxShadow: "0 10px 50px 0 rgba(0, 0, 0, 0.05)",
  },
  secondIcon: {
    height: { xs: "68px" },
    width: { xs: "68px" },
    color: theme.palette.green.main,
    mt: { xs: "42px" },
  },
  secondTitle: {
    color: theme.palette.blue.main,
    fontSize: { xs: "30px" },
    lineHeight: { xs: "32px" },
    maxWidth: { xs: "238px" },
    height: { xs: "68px" },
    fontFamily: theme.typography.montserrat.bold,
    textAlign: { xs: "center" },
    mt: { xs: "17px" },
  },
  secondSubtitle: {
    color: theme.palette.blue.main,
    fontFamily: theme.typography.anaHeim.regular,
    fontSize: { xs: "24px" },
    lineHeight: { xs: "36px" },
    maxWidth: { xs: "250px" },
    height: { xs: "179px" },
    mt: { xs: "10px" },
    textAlign: { xs: "center" },
  },
  thirdCard: {
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
    background: theme.palette.white.main,
    height: { xs: "483px" },
    width: { xs: "299px" },
    borderRadius: "47px",
    mt: { xs: "46px" },
    boxShadow: "0 10px 50px 0 rgba(0, 0, 0, 0.05)",
  },
  thirdIcon: {
    height: { xs: "74px" },
    width: { xs: "74px" },
    color: theme.palette.green.main,
    mt: { xs: "37px" },
  },
  thirdTitle: {
    color: theme.palette.blue.main,
    fontSize: { xs: "30px" },
    lineHeight: { xs: "32px" },
    maxWidth: { xs: "271px" },
    height: { xs: "80px" },
    fontFamily: theme.typography.montserrat.bold,
    textAlign: { xs: "center" },
    mt: { xs: "13px" },
  },
  thirdSubtitle: {
    color: theme.palette.blue.main,
    fontFamily: theme.typography.anaHeim.regular,
    fontSize: { xs: "24px" },
    lineHeight: { xs: "36px" },
    maxWidth: { xs: "262px" },
    height: { xs: "209px" },
    mt: { xs: "1rem" },
    textAlign: { xs: "center" },
  },
});

const StagesMobile = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { pathname } = useLocation();
  const { exercises, codingChallenge, personalInterview } = useTranslation(
    pathname,
    "StagesMobile"
  );

  return (
    <Box sx={classes.container}>
      <Box sx={classes.secondCard}>
        <img
          src={exercises.img.src}
          alt={exercises.img.alt}
          style={{ height: "57px", margin: "2rem" }}
        />
        <Typography sx={classes.secondTitle}>{exercises.title}</Typography>
        <Typography sx={classes.secondSubtitle}>
          {exercises.subtitle}
        </Typography>
      </Box>
      <Box sx={classes.firstCard}>
        <img
          src={codingChallenge.img.src}
          alt={codingChallenge.img.alt}
          style={{ height: "57px", margin: "2rem" }}
        />
        <Typography sx={classes.firstTitle}>{codingChallenge.title}</Typography>
        <Typography sx={classes.firstSubtitle}>
          {codingChallenge.subtitle}
        </Typography>
      </Box>

      <Box sx={classes.thirdCard}>
        <img
          src={personalInterview.img.src}
          alt={personalInterview.img.alt}
          style={{ height: "57px", margin: "2rem" }}
        />
        <Typography sx={classes.thirdTitle}>
          {personalInterview.title}
        </Typography>
        <Typography sx={classes.thirdSubtitle}>
          {personalInterview.subtitle}
        </Typography>
      </Box>

      <Box>
        <WantToStartButton
          mainColor="#00edd5"
          secondaryColor="#04a695"
          iconColor="#0feed7"
          mt="62px"
        />
      </Box>
    </Box>
  );
};

export default StagesMobile;
